<template>
  <b-dropdown :variant="variant" menu-class="constrained" :size="size" :disabled="disabled || busy" no-caret>
    <template #button-content>
      <div v-if="!busy && selected && selected != -1" class="text-primary">
        <i :class="`fa fa-fw fa-${icon}`"></i>
        {{ selected.name }}
        <i class="fa fa-fw fa-caret-down"></i>
      </div>
      <div v-if="!busy && selected && selected == -1" class="text-primary">
        <i :class="`fa fa-fw fa-${icon}`"></i>
        {{ trans('class_without_staff') }}
        <i class="fa fa-fw fa-caret-down"></i>
      </div>
      <div v-if="!busy && !selected" class="text-muted">
        <i v-if="!!icon" :class="`fa fa-fw fa-${icon}`"></i>
        {{ placeholder }}
        <i class="fa fa-fw fa-caret-down"></i>
      </div>
      <div v-if="busy" class="text-muted">
        <i class="fa fa-fw fa-circle-notch fa-spin"></i>
        {{ trans('please_wait') }}
      </div>
    </template>
    <b-dropdown-item @click="selected = null">
      <i v-if="!selected" class="fa fa-fw fa-check"></i>
      <i v-if="selected" class="fa fa-fw"></i>
      {{ nullValue }}
    </b-dropdown-item>
    <b-dropdown-item v-if="searchEmpty" @click="selected = -1">
      <i v-if="selected && selected.id == -1" class="fa fa-fw fa-check"></i>
      <i v-if="!selected || selected.id !== -1" class="fa fa-fw"></i>
      {{ trans('class_without_staff') }}
    </b-dropdown-item>
    <b-dropdown-item v-for="l in locations" :key="l.id" @click="selected = l">
      <i v-if="selected && selected.id == l.id" class="fa fa-fw fa-check"></i>
      <i v-if="!selected || selected.id != l.id" class="fa fa-fw"></i>
      <span>{{ l.name }}</span>
      <small v-if="!!l.amilia_location_id" class="text-muted">
        Amilia
      </small>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
  export default {
    props: {
      organization: Object,
      value: Number,
      variant: {
        type: String,
        default: 'light'
      },
      size: {
        type: String,
        default: 'md',
      },
      type: {
        type: String,
        default: null, // location, staff, equipment or null for any
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      icon: {
        type: String,
        default: 'filter',
      },
      placeholder: {
        type: String,
        default: trans('location'),
      },
      nullValue: {
        type: String,
        default: trans('filter_clear')
      },
      searchEmpty: {
        type: Boolean,
        default: false,
      },
      hideAmilia: {
        type: Boolean,
        default: false,
      },
      onlyWithAddress: {
        type: Boolean,
        default: false,
      },
      onlyClasses: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        trans: trans,
        busy: false,
        error: null,
        locations: [],
        selected: null,
        previous: null,
      }
    },
    watch: {
      selected() {
        let value = this.selected ? this.selected.id : null
        if(this.selected == -1) value = -1
        if (this.value != value)
          this.$emit('input', value)
        if (!_.isEqual(this.selected, this.previous)) {
          this.$emit('location', this.selected)
          this.previous = this.selected
        }
      },
      value() {
        let selected = _.find(this.locations, {id: this.value})
        if (this.value && selected) this.selected = selected
      },
    },
    methods: {
      fetch() {
        this.busy = true
        this.error = null
        let url = `/organization/${this.organization.id}/location/list?per_page=500`
        if (this.hideAmilia) url += '&hide_amilia=true'
        if (this.type) url += `&type=${this.type}`
        if (this.onlyWithAddress) url += '&only_with_address=true'
        if (this.onlyClasses) url += '&only_classes=true'
        return axios.get(url)
        .then(response => {
          this.busy = false
          this.locations = response.data.data
          if (this.value)
            this.selected = _.find(this.locations, {id: this.value})
          this.$emit('all-locations', this.locations)
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
          _.toastError(this, this.error)
        })
      },
    },
    mounted() {
      window.locationsDropdown = this
      this.fetch()
    },
  }
</script>